import React,{useContext} from "react";
import { posts,links } from "../data/posts";
import { useParams,Link } from "react-router-dom";
import ThemeContext from '../context/ThemeContext'

import "./CardDetail.css";
import Accordion from './../components/Accordion/Accordion';
const CardDetail = () => {
  const { theme } = useContext(ThemeContext);

  const { id } = useParams(); // Extract 'id' from the URL
  const postIndex = parseInt(id, 10) - 1; // Convert `id` to integer and adjust for 0-based index
  if (isNaN(postIndex) || postIndex < 0 || postIndex >= posts.length) {
    return <p>Post not found!</p>;
  }
  const post = posts[postIndex];

  if (!post) return <p>Post not found!</p>;
  console.log(post, id);
  const hasImages = post.images && Object.keys(post.images).length > 0;
  const hasCreators = post.creators && Object.keys(post.creators).length > 0;

  return (
    <div>
      <div className="container">
        {/*  <!-- video preview --> */}
        <div className="video_previwe">
          <div className="video_wrapper">
            <iframe
              src={post.src}
              allow="autoplay;fullscreen"
              allowFullScreen
              title={post.name}
            ></iframe>
          </div>
        </div>
      </div>
      {/*  <!-- description for project or video --> */}
      <div className={`description ${theme}`}>
        <h2>{post.name}</h2>
        <p>
          {post.description}
        </p>
      </div>
     
    
     {hasCreators ?(
       <Accordion >
        <p>{post.creators.A}</p>
        <p>{post.creators.B}</p>
        <p>{post.creators.C}</p>
        <p>{post.creators.D}</p>
        <p>{post.creators.E}</p>
        <p>{post.creators.F}</p>
        <p>{post.creators.G}</p>
        <p>{post.creators.H}</p>
        <p>{post.creators.I}</p>
        <p>{post.creators.J}</p>
        <p>{post.creators.K}</p>
        </Accordion>
     ): (<p style={{textAlign:'center',color:'red'}}>No creators available for this project.</p>)}
     

     
  
      {/*  <!-- images related to the video or project --> */}
      <div className="pic_container">
      {hasImages ? (
          Object.values(post.images).map((imageUrl, index) => (
            <img
              key={index}
              src={imageUrl}
              alt={`${index + 1}`}
              className="project-image"
            />
          ))
        ) : (
          <p>No images available for this project.</p>
        )}

      </div>

      {/* <!-- links to related posts --> */}
      <div className="link_post">
        {links.map((url, index) => (
          <div key={index}  >
            <Link className={`post_link ${theme}`}  to={url.url}  rel="noopener noreferrer">
            {url.name}
            </Link>
          <span>/</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardDetail;
